import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { BymeService } from '../../services/byme.service';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { CONTEXT } from 'src/app/enum/context';

@Component({
  selector: 'ng-hbm-bdi-configuration',
  templateUrl: './configuration.component.html'
})
export class ConfigurationComponent implements OnInit, AfterViewInit, OnDestroy {

  customerName: string;

  constructor(private byMe: BymeService, private customer: UserService, private router: Router) { }

  ngOnInit(): void {
    let _route = this.router.url.split("/")[1];
    switch (_route) {
      case CONTEXT.KITCHEN:
        this.customer.context = CONTEXT.KITCHEN;
        break;
      case CONTEXT.STORAGE:
        this.customer.context = CONTEXT.STORAGE;
        break;
      case CONTEXT.BATHROOM:
        this.customer.context = CONTEXT.BATHROOM;
        break;
      default:
        break;
    }
    
    if (this.customer.userDatas) {
      if (this.customer.userDatas.otherAccount) {
        this.customerName = this.customer.userDatas.otherAccount.completeName;
      }
    }
  }

  ngAfterViewInit(): void {
    this.byMe.initIframe(document.getElementById("byMeIframe") as HTMLIFrameElement);
  }

  ngOnDestroy(): void {
    this.byMe.iframe = null;
  }
}
